import { defineStore } from 'pinia'
import { ref, computed } from 'vue'

export const AUTH_STATE = {
  IDLE: 'idle',
  AUTHENTICATING: 'authenticating',
  AUTHENTICATED: 'authenticated',
  LOGIN_SUCCESS: 'loginSuccess',
  TOKEN_AUTHENTICATED: 'tokenAuthenticated',
  INLINE: 'inline',
  LOGIN: 'login',
}

export const useAuthStore = defineStore('auth', () => {
  // State
  const authState = ref(AUTH_STATE.IDLE)
  const isPlaying = ref(false)
  const loginData = ref({
    provider: '',
    countryCode: null,
    phone: null,
    email: null,
    username: null,
    password: null,
  })
  const fc = ref(null)
  const deviceTokenChecked = ref(false)
  // 自動登入進行中旗標：用於抑制錯誤彈窗、避免登入途中被輪詢登出
  const isAutoLoggingIn = ref(false)
  // 回前景 /self 探測窗旗標：早於 isAutoLoggingIn 設立，抑制探測期間（含 _checkToken A103 與並行輪詢）的錯誤彈窗
  const isRevivingSession = ref(false)
  // 背景 episode 旗標：退背景/切分頁（已登入）時設起，標記「正處於一段背景，其結局尚未由回前景流程裁決」。
  // 期間任何 session 流失訊號（token ref 因 maxAge 歸零、/self 或其他 API 的失效碼）皆不直接登出/導頁，
  // 一律延後交給回前景的 reviveSession 裁決。嚴格綁定 visibility，回前景必清，故只影響背景→前景情境。
  const isBackgroundEpisode = ref(false)

  // Getters
  const getAuthState = computed(() => authState.value)
  const getIsPlaying = computed(() => isPlaying.value)
  const getLoginData = computed(() => loginData.value)
  const getFc = computed(() => fc.value)
  const isAuthenticated = computed(() => authState.value === AUTH_STATE.AUTHENTICATED)
  const isAuthenticating = computed(() => authState.value === AUTH_STATE.AUTHENTICATING)

  // Actions
  const setAuthState = (state) => {
    authState.value = state
  }

  const setIsPlaying = (playing) => {
    isPlaying.value = playing
  }

  const setLoginData = (data) => {
    loginData.value = { ...loginData.value, ...data }
  }

  const resetLoginData = () => {
    loginData.value = {
      provider: '',
      countryCode: null,
      phone: null,
      email: null,
      username: null,
      password: null,
    }
  }

  const setFc = (value) => {
    fc.value = value
  }

  const setAutoLoggingIn = (value) => {
    isAutoLoggingIn.value = value
  }

  const setRevivingSession = (value) => {
    isRevivingSession.value = value
  }

  const setBackgroundEpisode = (value) => {
    isBackgroundEpisode.value = value
  }

  return {
    // State
    authState,
    isPlaying,
    loginData,
    fc,
    deviceTokenChecked,
    isAutoLoggingIn,
    isRevivingSession,
    isBackgroundEpisode,
    // Getters
    getAuthState,
    getIsPlaying,
    getLoginData,
    getFc,
    isAuthenticated,
    isAuthenticating,
    // Actions
    setAuthState,
    setIsPlaying,
    setLoginData,
    resetLoginData,
    setFc,
    setAutoLoggingIn,
    setRevivingSession,
    setBackgroundEpisode,
  }
})
